import usePermissions from '../../../../../../hooks/usePermissions'
import { GAM_LINE_ITEM_ADVANCED_SETTINGS } from '../../../../../../constants/permissions'

export const useCanManageAdvancedSettings = () => {
  const permissions = usePermissions()

  return permissions.can('manage', GAM_LINE_ITEM_ADVANCED_SETTINGS)
}
